<template>
  <transition name="fade" mode="out-in">
    <div v-if="isLoading" class="my-5 mx-5 wrapper-project" key="loading-list">
      <ListSkeleton />
    </div>

    <div v-else class="pt-5 wrapper-project" id="listBS" key="main-list">
      <InputSearchGlobal :title="titleStack" />

      <div class="notification-buttons">
        <ButtonApp
          v-for="countData in notificationTab"
          :key="countData.label"
          type="is-ghost"
          @click="handleNotificationClick(countData)"
          :isSecondary="true"
        >
          <b-icon :icon="countData.label === 'Summary' ? 'cash-multiple' : 'bell'"></b-icon>
          <span style="font-weight: bold;">
            {{ countData.label }} <b-tag rounded v-if="countData.label !== 'Summary'"> {{ countData.count }} </b-tag>
          </span>
        </ButtonApp>
      </div>

      <b-tabs v-model="activeTab">
        <b-tab-item v-for="countData in countDataTabs" :key="countData.label">
          <template #header>
            <div v-if="countData.label !== 'Tagihan Proyek'">
              <b-icon icon="information"></b-icon>
              <span>
                {{ countData.label }} <b-tag rounded> {{ countData.count }} </b-tag>
              </span>
            </div>
          </template>

          <!-- currentTab untuk Load More sedangkan activeTab untuk menyimpan tab ketika go to page detail -->
          <ListSurvey
            v-if="countData.label === 'Survey'"
            type="survey"
            selectedSubstatus="late"
            :activeTab="0"
            :currentTab="0"
            :selectedTab="activeTab"
            :triggerAPIFromScroll="triggerScroll"
            :triggerTop="triggerTop"
            @reloadData="countTotalDataTabs($event)"
          />
          <ListPenawaran
            v-if="countData.label === 'Approval'"
            type="offering"
            selectedSubstatus="internal"
            :activeTab="1"
            :currentTab="1"
            :selectedTab="activeTab"
            :triggerAPIFromScroll="triggerScroll"
            :triggerTop="triggerTop"
            @reloadData="countTotalDataTabs($event)"
          />
          <ListProyek
            v-if="countData.label === 'Proyek'"
            type="project-active"
            selectedSubstatus="in-planning"
            :activeTab="2"
            :currentTab="2"
            :selectedTab="activeTab"
            :triggerAPIFromScroll="triggerScroll"
            :triggerTop="triggerTop"
            @reloadData="countTotalDataTabs($event)"
          />
          <ListProyek
            v-if="countData.label === 'Pembayaran'"
            type="project-complete"
            selectedSubstatus="waiting"
            :isPayment="true"
            :activeTab="3"
            :currentTab="3"
            :selectedTab="activeTab"
            :triggerAPIFromScroll="triggerScroll"
            :triggerTop="triggerTop"
            @reloadData="countTotalDataTabs($event)"
          />

          <!-- <div v-if="countData.label === 'Tagihan Proyek'" class="container-tab-wrapper tagihan-wrapper">
            <div class="px-5">
              <ListTagihanProyek
                :activeTab="4"
                :selectedTab="activeTab"
                :triggerAPIFromScroll="triggerScroll"
                :triggerTop="triggerTop"
              />
            </div>
          </div> -->

          <!-- <ListProyek v-if="countData.label == 'Proyek Lunas'" action="getListProyekLunas" :isPayment="true" :showPaymentDate="true" /> -->
        </b-tab-item>
      </b-tabs>

      <ModalPaymentNotifications
        :showModal="showModalPaymentNotifications"
        width="75vw"
        @closeModal="closeNotificationModal"
        @totalReschedule="totalReschedule($event)"
        :dataNotifikasi="selectedNotificationData"
        :dataPayment="dataPayment"
        :statusNotification="statusNotification"
      />

      <ModalPaymentSummary
        :showModal="showModalPaymentSummary"
        width="75vw"
        @closeModal="closePaymentSummaryModal"
        :dataSummary="dataSummary"
      />

      <div>
        <ButtonScrollTop :offsetWindowScroll="200" elementPoint="listBS" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ListProjectAM',
  components: {
    ListSkeleton: () => import('@/components/skeleton/ListSkeleton'),
    ListSurvey: () => import('@/components/project/list/ListSurvey.vue'),
    ListPenawaran: () => import('@/components/project/list/ListPenawaran.vue'),
    ListProyek: () => import('@/components/project/list/ListProyek.vue'),
    InputSearchGlobal: () => import('@/components/project/list/InputSearchGlobal'),
    ButtonScrollTop: () => import('@/components/button/ButtonScrollTop.vue'),
    ButtonApp: () => import('@/components/button/ButtonApp.vue'),
    ModalPaymentNotifications: () => import('@/components/modal/ModalPaymentNotifications.vue'),
    ModalPaymentSummary: () => import('@/components/modal/ModalPaymentSummary.vue')
  },
  computed: {
    titleStack () {
      return ['Proyek']
    },
    ...mapGetters({
      url: 'setup/getUrl',
      tab: 'list/getSelectedTabList',
      tabPersist: 'list/getPersistTabProject'
    })
  },
  data () {
    return {
      isLoading: false,
      countDataTabs: null,
      activeTab: 0,
      triggerScroll: 0,
      triggerTop: false,
      callCountTabs: false,
      showModalPaymentNotifications: false,
      showModalPaymentSummary: false,
      selectedNotificationData: null,
      notificationTab: [],
      isLoadingNotifications: false,
      dataPayment: {},
      dataSummary: [],
      statusNotification: null
    }
  },
  methods: {
    /**
     * Fetch notification tabs dari API
     */
    async fetchNotificationTabs () {
      this.isLoadingNotifications = true
      try {
        const response = await this.$store.dispatch('notificationPayment/getNotificationTabs', {
          url: this.url
        })

        if (response && response.data && response.data.data) {
          // Map data dari API ke format yang dibutuhkan component
          this.notificationTab = [
            ...response.data.data.tabs.map(tab => ({
              label: tab.label,
              count: tab.count,
              status: tab.status,
              key: tab.key,
              icon: tab.icon,
              color: tab.color
            })),
            {
              label: 'Summary',
              count: response.data.data.totalCount,
              status: 'summary',
              key: 'summary',
              icon: 'clipboard-list',
              color: 'primary'
            }
          ]
        }
      } catch (error) {
        console.error('Error fetching notification tabs:', error)
        this.$buefy.toast.open({
          message: 'Gagal memuat notifikasi pembayaran',
          type: 'is-danger',
          duration: 3000
        })

        // Fallback ke empty array jika error
        this.notificationTab = []
      } finally {
        this.isLoadingNotifications = false
      }
    },

    /**
     * Refresh notification count
     */
    async refreshNotificationCount () {
      await this.fetchNotificationTabs()
    },

    /**
     * Handle notification button click
     */
    async handleNotificationClick (data) {
      console.log('Notification clicked:', data.label, data)

      // Store status yang dipilih
      this.selectedNotificationStatus = data.status

      if (data.label === 'Summary') {
        // Untuk summary, fetch semua data
        await this.fetchSummaryData()
        this.showModalPaymentSummary = true
      } else {
        // Untuk notifikasi spesifik, fetch berdasarkan status
        await this.fetchNotificationsByStatus(data.status)
        this.showModalPaymentNotifications = true
      }
      this.selectedNotificationData = data
    },

    async fetchNotificationsByStatus (status) {
      try {
        // Show loading di modal (bisa handle di component modal)
        const response = await this.$store.dispatch('notificationPayment/getNotificationList', {
          url: this.url,
          status: status,
          page: 1,
          limit: 5, // atau sesuai kebutuhan
          sortBy: 'created_at',
          sortOrder: 'desc'
        })
        console.log('Fetched notifications for status:', status, response)
        this.dataPayment = response.data.data
        this.statusNotification = status
      } catch (error) {
        console.error('Error fetching notifications by status:', error)
        this.$buefy.toast.open({
          message: 'Gagal memuat data notifikasi',
          type: 'is-danger',
          duration: 3000
        })
      }
    },

    /**
     * NEW: Fetch summary data
     */
    async fetchSummaryData () {
      try {
        const response = await this.$store.dispatch('notificationPayment/getSummary', {
          url: this.url
        })

        console.log('Fetched summary data:', response.data.data)

        this.dataSummary = response.data.data
      } catch (error) {
        console.error('Error fetching summary:', error)
        this.$buefy.toast.open({
          message: 'Gagal memuat summary',
          type: 'is-danger',
          duration: 3000
        })
      }
    },
    closeNotificationModal () {
      this.showModalPaymentNotifications = false
      this.selectedNotificationData = null
      this.selectedNotificationStatus = null
      // Refresh count setelah modal ditutup (ada kemungkinan data berubah)
      this.refreshNotificationCount()
    },

    /**
     * Close payment summary modal
     */
    closePaymentSummaryModal () {
      this.showModalPaymentSummary = false
      this.selectedNotificationData = null
      // Refresh count setelah modal ditutup
      this.refreshNotificationCount()
    },

    /**
     * Callback dari modal reschedule
     */
    totalReschedule (event) {
      console.log('Total reschedule:', event)
      // Refresh notification count setelah reschedule
      this.refreshNotificationCount()
    },

    /**
     * Get icon untuk button
     */
    getButtonIcon (countData) {
      if (countData.icon) {
        return countData.icon
      }
      return countData.label === 'Summary' ? 'clipboard-list' : 'bell'
    },

    // EXISTING METHODS
    countTotalDataTabs (props) {
      if (this.callCountTabs) return

      if (!props || !props.disableLoading) {
        this.isLoading = true
      } else {
        this.callCountTabs = true
      }
      if (props && props.fromDetail) {
        this.$store.commit('list/resetPersistTabProject')
        this.$store.commit('list/resetPersistDataList')
      }

      const body = {
        url: this.url
      }

      if (props && props.vendor) {
        body.vendor = props.vendor
      }

      this.$store
        .dispatch('projectV2/getTabsProject', body)
        .then(response => {
          this.countDataTabs = response.data.data
          this.isLoading = false
          this.persistDataTab()
          this.callCountTabs = false
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
        })
    },

    handleScroll () {
      const windowHeight = window.innerHeight
      const scrollY = window.scrollY || window.pageYOffset
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      )

      const offset = 250

      if (documentHeight - (scrollY + windowHeight) < offset) {
        this.triggerScroll += 1
      }

      if (scrollY >= 100) {
        this.triggerTop = true
      } else if (scrollY === 0) {
        this.triggerTop = false
      }
    },

    persistDataTab () {
      const storeObj = {
        countDataTabs: this.countDataTabs,
        activeTab: this.activeTab
      }
      this.$store.commit('list/setPersistTabProject', storeObj)
    }
  },

  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.activeTab = this.tab || 0
  },

  beforeRouteLeave (to, from, next) {
    const destinationPath = to.path
    const parts = destinationPath.split('/')
    const lastPart = parts.pop()

    if (lastPart !== 'detail') {
      this.$store.commit('list/resetPersistTabProject')
      this.$store.commit('list/resetPersistDataList')
    }
    next()
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    this.triggerScroll = 0
  },

  created () {
    // Restore tab data jika ada
    if (this.tabPersist && Object.keys(this.tabPersist).length > 0) {
      const { countDataTabs, activeTab } = this.tabPersist
      this.countDataTabs = countDataTabs
      this.activeTab = activeTab
      this.isLoading = false
    } else {
      this.countTotalDataTabs()
    }

    // FETCH NOTIFICATION TABS
    this.fetchNotificationTabs()
  },

  watch: {
    activeTab (val) {
      this.$store.commit('list/setSelectedTabList', val)
      this.$store.commit('list/setPersistDataList', { activeTab: val })
      this.persistDataTab()
    }
  }
}
</script>

<style scoped>
.wrapper-project {
  width: 95%;
  margin: auto;
}

.tagihan-wrapper {
  background: #fff;
  padding-top: 10px;
  margin-left: -16px !important;
  margin-top: -15px !important;
}

.tab-header-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}

.notification-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-bottom: 1rem;
  position: relative;
}

.notification-loading-wrapper {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 10;
}

.notification-buttons .button.is-ghost {
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.notification-buttons .button.is-ghost:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.05);
}

.notification-buttons .button.is-ghost:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.notification-buttons span .tag {
  background-color: #f14668;
  color: white;
  transition: all 0.3s ease;
}

.notification-buttons .button:hover:not(:disabled) span .tag {
  background-color: white;
  color: #f14668;
  border: 1px solid #f14668;
}

/* Spin animation untuk refresh button */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spin-icon {
  animation: spin 1s linear infinite;
}

/* Badge type colors */
.tag.is-warning {
  background-color: #ff9800;
}

.tag.is-info {
  background-color: #2196F3;
}

.tag.is-danger {
  background-color: #f14668;
}

.tag.is-success {
  background-color: #4caf50;
}

.tag.is-primary {
  background-color: #7957d5;
}
</style>

<style>
.wrapper-project .tab-content {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
